import React from "react"
import styled from "@emotion/styled"

const YoutubeModal = ({ srcId, handleClose }) => {
  return (
    <Wrapper onClick={handleClose}>
      <Youtube>
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${srcId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Youtube>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
`

const CloseButton = styled.div`
  position: absolute;
  top: 2%;
  right: 2%;
  z-index: 99999;
`

const Youtube = styled.div`
  padding-top: 42.1875%;
  position: relative;
  width: 75%;
  iframe {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`

export default YoutubeModal
